import { gql } from 'graphql-tag';

export const USER_LOCATION = gql`
  query userLocation {
    userLocation {
      locationId
    }
  }
`;
